import styled from '@emotion/styled';

export const Container = styled.div`
	background-color: var(--modal-bg-3);
	border-radius: var(--small-border-radius);
	z-index: var(--z-index-10);
	overflow: auto;
	box-shadow: var(--container-box-shadow);
	padding: var(--padding-2);
	max-width: 100vw;
	overflow: auto;
`;

export const Item = styled.div`
	display: flex;
	flex-direction: row;
	cursor: pointer;
	justify-content: space-between;
	border-radius: var(--small-border-radius);

	:hover,
	:focus,
	:active {
		background-color: var(--table-selected-color);
	}
`;

export const Cell = styled.div`
	flex: ${({ width }) => width ?? 200} 1 auto;
	width: ${({ width }) => width ?? 200}px;
	padding: var(--padding-2);
	overflow: hidden;
	display: flex;
	align-items: center;
`;
